export const server_api = process.env.PUBLIC_URL;
export const lang = process.env.LANG;
